import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { deleteAudioAnnouncementFile } from '../../services/AudioAnnouncementService';
import type { DeleteAudioAnnouncementFileRequest } from '../../types/AudioAnnouncement';

type Result = UseMutationResult<void, Error, DeleteAudioAnnouncementFileRequest>;

function useDeleteAudioAnnouncementFile(
  successCb: () => void,
  failureCb: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteAudioAnnouncementFile, {
    onSuccess: (_, variables) => {
      successCb();
      queryClient.invalidateQueries({
        queryKey: ['audio-announcement', variables.fleetId],
      });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteAudioAnnouncementFile;
